var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatherUploadCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32L24.5 24L16.5 32",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24V42",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.28 36.78C43.2307 35.7165 44.7717 34.0338 45.6598 31.9973C46.5479 29.9607 46.7325 27.6865 46.1845 25.5334C45.6364 23.3803 44.387 21.471 42.6334 20.1069C40.8797 18.7428 38.7218 18.0015 36.5 18H33.98C33.3747 15.6585 32.2464 13.4847 30.6799 11.642C29.1135 9.7993 27.1497 8.3357 24.9362 7.36121C22.7227 6.38673 20.3171 5.92672 17.9003 6.01576C15.4834 6.10481 13.1182 6.7406 10.9824 7.87533C8.84662 9.01006 6.99586 10.6142 5.56929 12.5672C4.14271 14.5201 3.17742 16.7711 2.746 19.1508C2.31458 21.5305 2.42825 23.9771 3.07847 26.3065C3.72869 28.636 4.89853 30.7877 6.50004 32.6",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32L24.5 24L16.5 32",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherUploadCloud);
export default __webpack_public_path__ + "static/media/feather_upload-cloud.48d9bf66fde7c3107d6316732cd6b9e7.svg";
export { ForwardRef as ReactComponent };